import { render, staticRenderFns } from "./SubNavBar.vue?vue&type=template&id=5f899fd9&scoped=true&"
import script from "./SubNavBar.vue?vue&type=script&lang=js&"
export * from "./SubNavBar.vue?vue&type=script&lang=js&"
import style0 from "./SubNavBar.vue?vue&type=style&index=0&id=5f899fd9&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f899fd9",
  null
  
)

export default component.exports